import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

//Controls
import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
} from "@gpstrackit/react-controls";
import ReactJsonViewCompare from 'react-json-view-compare';

//Actions
import {
    clearRedux
} from 'Redux/actions'

const CoverageDetailInfo = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const { openModal, loading, details } = useSelector(state => state.coverageDetailInfoRedux);

    const closeModal = () => {
        dispatch(clearRedux("COVERAGE_DETAIL_INFO"));
    }

    return (
        <Modal
            open={openModal}
            title={messages['coverage_details_diagnostic_details']}
            handleClose={() => closeModal()}
            position="right"
            size="small"
            loading={loading}
        >
            <ModalBody>
                <div style={{ padding: '0 10px', marginBottom: 30 }}>
                    <pre>
                        {details || <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center', marginTop: 10, opacity: 0.5 }}>{messages['common_no_information_to_display']}</div>}
                    </pre>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    onClick={() => closeModal()}
                    className="btn-dark-blue"
                >
                    {messages['close']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default CoverageDetailInfo;